import { useState } from 'react'
import { Popover } from 'antd'
import cn from 'classnames'
import { ReactComponent as Close24 } from 'assets/svg/Close24.svg'
import { TDescriptionCellProps } from './types'
import './styles.scss'
import { Typography, TYPOGRAPHY_WEIGHT } from '../Typography'

export const DescriptionCell = ({
  content,
  text,
  triggerElement,
  className,
  trigger = 'click',
  title
}: TDescriptionCellProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const handleSetIsOpen = (open) => setIsOpen(open)
  return content ? (
    <Popover
      className={cn('description-cell', className)}
      trigger={trigger}
      placement="topLeft"
      content={content}
      overlayInnerStyle={{
        maxHeight: 'calc(100vh - 100px)',
        overflow: 'auto'
      }}
      align={{
        points: ['tl', 'tl']
      }}
      visible={isOpen}
      onVisibleChange={handleSetIsOpen}
      title={
        <div className="description-cell__content-header row space-between gap-24">
          <Typography.Headline6 weight={TYPOGRAPHY_WEIGHT.MEDIUM}>
            {!!title && title}
          </Typography.Headline6>
          <div
            className="description-cell__close"
            onClick={() => setIsOpen(false)}
          >
            <Close24 />
          </div>
        </div>
      }
    >
      {triggerElement ? (
        triggerElement
      ) : (
        <div className="description-cell__text" onClick={() => setIsOpen(true)}>
          {text}
        </div>
      )}
    </Popover>
  ) : (
    <>–</>
  )
}
